import AbstractGeoLoc from '@phoenix/components/AbstractGeoLoc';
import { Collapse } from '@maison/Toolkit';

export default class GeoLoc extends AbstractGeoLoc {
  static readonly CLOSED_BANNER_STORAGE_KEY = 'closedMarketBanner';
  static readonly CLOSE_BANNER_BUTTON_ID = 'close-market-banner-button';

  /**
   * Show the proposition banner inside a promotion block
   */
  showPropositionBanner(): void {
    const collapse = document.querySelector(this.COUNTRY_PROPOSITION_BANNER_SELECTOR);
    if (collapse) {
      collapse.classList.add('is-expanded');
      new Collapse(collapse);
    }
    const closeBannerButton = document.querySelector(`#${GeoLoc.CLOSE_BANNER_BUTTON_ID}`);

    if (closeBannerButton) {
      closeBannerButton.addEventListener('click', () => {
        localStorage.setItem(GeoLoc.CLOSED_BANNER_STORAGE_KEY, 'true');
      });
    }

    document.querySelectorAll('.country-proposition-item').forEach((locationButton) => {
      locationButton.addEventListener('click', (event) => {
        localStorage.setItem(GeoLoc.CLOSED_BANNER_STORAGE_KEY, 'true');
      });
    });
  }

  shouldShowBanner(countryCodeFromIP): boolean {
    return localStorage.getItem(GeoLoc.CLOSED_BANNER_STORAGE_KEY) === null || super.shouldShowBanner(countryCodeFromIP);
  }
}
